/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {SimilarClientMatch} from "./similarClientMatch.zod";
import {SimilarLeadMatch} from "./similarLeadMatch.zod";

export const SimilarCompanyMatch = zod.union([SimilarLeadMatch, SimilarClientMatch]);

export type SimilarCompanyMatch = zod.input<typeof SimilarCompanyMatch>;
export type SimilarCompanyMatchOutput = zod.output<typeof SimilarCompanyMatch>;
